import { twMerge } from 'tailwind-merge';

export default function highlightMatchedText(text, keyword, className) {
  if (!text || !keyword) return text;

  const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/gi, '\\$&');

  const regex = new RegExp(
    `(<span class="${twMerge('font-medium', className)}">.*?</span>)|(${escapedKeyword})`,
    'gi'
  );

  return text.replace(regex, (match, span, word) => {
    if (span) return span;

    if (word) {
      return `<span class="${twMerge('font-medium', className)}">${word}</span>`;
    }

    return match;
  });
}
